<template>
  <div>
    <!-- 顶部 -->
    <div class="head">
      <h1 @click="navigateHome">小码模板</h1>
      <p>
        【登记去向,不重复】
      </p>
    </div>

    <!-- 搜索 -->
  </div>
</template>

<script>
export default {
  name: 'SidebarSearch',
  methods: {
    navigateHome() {
      if (this.$route.path !== '/') {
        this.$router.replace('/'); // 替代 push
      }
    },
  },
};
</script>

<style scoped>
.head {
  height: 11vw; /* 高度使用vw */
  display: flex;
  justify-content: space-between;
  background-color: #854685;
}

.head p {
  margin: 4vw; /* 外边距使用vw */
  font-size: 4vw; /* 字体大小使用vw */
  color: #fff;
}

.head h1 {
  color: #fff;
  color: #FFFFE0;
  padding: 2.2vw 3vw; /* 内边距使用vw */
  font-family: "楷体";
  font-size: 6vw; /* 字体大小使用vw */
}
</style>
